<template>
  <div
    class="terminal-download-page"
    :class="{
      'client-eval-page--indiv': isIndiv,
      'terminal-download-page--indiv': isIndiv,
    }"
  >
    <div
      class="terminal-download-page__scroll"
      :class="{ 'indiv-scrollbar': isIndiv }"
    >
    <div class="download_banner">
      <li style="overflow: hidden;"></li>
      <div class="download_title">
        <div class="download_title-brand">
          <img
            class="download_title-logo"
            :src="imgDzh2"
            alt="易小助"
          />
          <div class="download_title-text">
            <p class="download_title-name">
              杰宜斯易小助<img
                class="download_title-reg"
                :src="imgReg"
                alt=""
              />
            </p>
            <p class="download_title-sub">多账户交易端软件</p>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;gap: 80px;">
          <a href="/api/upload/JeesMTCPEAutoUpdate/JeesMTCPESetup.exe"
            ><img
              v-show="!show"
              class="btn_img"
              :src="imgBtn01"
              alt=""
              @mouseover="mouseover_img"
            />
            <img
              v-show="show"
              class="btn_img"
              :src="imgBtn02"
              alt=""
              @mouseout="mouseout_img"
          /></a>

          <img
            v-show="!show1"
            class="btn_img"
            :src="imgUserManual"
            alt=""
            @mouseover="mouseover_img1"
          />
          <img
            v-show="show1"
            class="btn_img"
            :src="imgUserManual1"
            alt=""
            @click="pushManual()"
            @mouseout="mouseout_img1"
          />
        </div>
      </div>
      <div class="img_box">
        <img class="pcImg" :src="imgPc01" alt="" />
      </div>
    </div>
    <div class="msg3" style="padding-top: 250px;position: relative;background-color:#f8f9fb">
      <div
        class="banner2"
        :style="{
          width: width_,
          display: 'flex',
          height: '540px',
          alignItems: 'center'
        }"
      >
        <div
          class="b_right"
          style="width: 560px;margin-right: 50px;margin-left: 50px;"
        >
          <h2 style="margin-bottom: 30px;font-size: 36px;color: #0a101e;">
            账户分组功能
          </h2>
          <p
            style="font-size: 28px;line-height: 40px;color: #8997ab;font-weight: 300;"
          >
            支持多个账户进行分组管理，设置分组倍率，<br />实现多个账户同时进行批量交易。
          </p>
        </div>
        <div
          class="b_left"
          :style="{
            maxWidth: '492px',
            background: backgroundImage1,
            backgroundSize: '100%',
            flex: '1',
            height: '100%'
          }"
        ></div>
      </div>
    </div>

    <div class="msg2">
      <div
        class="banner2"
        :style="{
          width: width_,
          display: 'flex',
          height: '540px',
          alignItems: 'center'
        }"
      >
        <div
          class="b_left"
          :style="{
            maxWidth: '466px',
            background: backgroundImage2,
            backgroundSize: '100%',

            flex: '1',
            height: '100%'
          }"
        ></div>
        <div
          class="b_right"
          style="width: 560px;margin-right: 50px;margin-left: 150px;"
        >
          <h2 style="margin-bottom: 30px;font-size: 36px;color: #0a101e;">
            自设套利
          </h2>
          <p
            style="font-size: 28px;line-height: 40px;color: #8997ab;font-weight: 300;"
          >
            支持非交易所标准套利合约以外的套利交易。
          </p>
        </div>
      </div>
    </div>
    <div class="msg3" style="position: relative;">
      <div
        class="banner2"
        :style="{
          width: width_,
          display: 'flex',
          height: '540px',
          alignItems: 'center'
        }"
      >
        <div
          class="b_right"
          style="width: 560px;margin-right: 50px;margin-left: 50px;"
        >
          <h2 style="margin-bottom: 30px;font-size: 36px;color: #0a101e;">
            云条件单
          </h2>
          <p
            style="font-size: 28px;line-height: 40px;color: #8997ab;font-weight: 300;"
          >
            提供价格条件单、状态条件单、时间条件单及预埋条件单，类型多样，设置灵活。
          </p>
        </div>
        <div
          class="b_left"
          :style="{
            maxWidth: '492px',
            background: backgroundImage3,
            backgroundSize: '100%',
            flex: '1',
            height: '100%'
          }"
        ></div>
      </div>
    </div>
    <div style="position: relative;margin-top: 195px;">
      <foot />
    </div>
    </div>

    <ConsultFloatBar />

    <transition name="el-fade-in-linear">
      <div
        v-show="code_show"
        class="wxCode"
        @click.stop.prevent="code_show = false"
      >
        <div
          class="wxBox"
          style="background-color: #fff;width: 400px;padding-top: 1px;text-align: center;"
          @click.stop.prevent="stop"
        >
          <h2 style="color: #000;margin-top: 20px;">Android</h2>
          <div class="code"><canvas id="QRCode" /></div>
          <h3 style="margin-top: 30px;font-size: 18px;">
            请使用安卓手机浏览器
          </h3>
          <h3 style="font-size: 18px;">扫描图片二维码下载安装</h3>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/** 终端下载（from=indiv）：PC 安装包、Android 二维码、使用手册 */
import foot from '@/components/footer/index';
import ConsultFloatBar from '@/components/consultFloatBar/index.vue';
import { isIndivMixin } from '@/utils/isIndiv';
import './style.css';
import QRCode from 'qrcode';

export default {
  name: 'ClientTerminalDownload',
  mixins: [isIndivMixin],
  components: { foot, ConsultFloatBar },
  data() {
    return {
      imgDzh2: require('./imgs/icon.png'),
      imgReg: require('./imgs/R.png'),
      imgBtn01: require('@/assets/images/btn01.png'),
      imgBtn02: require('@/assets/images/btn02.png'),
      imgUserManual: require('@/assets/images/userManual.png'),
      imgUserManual1: require('@/assets/images/userManual1.png'),
      imgPc01: require('./imgs/t.png'),
      code_show: false,
      QRCodeMsg: '',
      appUrl: '',
      MHeight: document.documentElement.clientHeight - 50 + 'px',
      show: false,
      show1: false,

      width_: '1200px',
      screenWidth: document.body.clientWidth,
      backgroundImage1:
        'url(' + require('@/assets/images/bg/page4.png') + ') no-repeat center',
      backgroundImage2:
        'url(' + require('@/assets/images/bg/page5.png') + ') no-repeat center',
      backgroundImage3:
        'url(' + require('@/assets/images/bg/page6.png') + ') no-repeat center',
    };
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;

    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };

    this.$request.post('/app/get_new', null, { skipToken: true, rawResponse: true }).then((res) => {
      this.tokenInvalid(res);
      if (res.data.code == 200) {
        this.appUrl = res.data.data.filePath;
      }
    });
  },
  methods: {
    mouseover_img() {
      this.show = true;
    },
    mouseout_img() {
      this.show = false;
    },
    mouseover_img1() {
      this.show1 = true;
    },
    mouseout_img1() {
      this.show1 = false;
    },
    getQRCode() {
      this.QRCodeMsg = 'https://yunsrvwebapi.jeesit.com' + `${this.appUrl}`;
    },
    pushManual() {
      const q = { ...(this.$route.query || {}) };
      if (String(q.type) === '9') delete q.type;
      this.$router.push({
        path: '/index/help/faq',
        query: { ...q, from: 'indiv', type: '9' },
      });
    },
    stop() {},
  },
  watch: {
    screenWidth() {
      if (this.screenWidth < 1039 && this.screenWidth > 768) {
        this.width_ = '750px';
      }
      if (this.screenWidth > 1040 && this.screenWidth < 1180) {
        this.width_ = '1040px';
      }
      if (this.screenWidth > 1180) {
        this.width_ = '1200px';
      }
      if (this.screenWidth < 750) {
        this.width_ = '980px';
      }
    },
    QRCodeMsg(val) {
      const msg = document.getElementById('QRCode');
      QRCode.toCanvas(msg, val, function () {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/client/terminal-download/index.vue